'use client';

import { categories } from '@/@constants';
import { CategoryConstantType } from '@/@types';
import { Button, Dropdown, Element, Icon, useMediaQuery } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { useLingui } from '@lingui/react';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import * as styles from './category-selector.styles';

// eslint-disable-next-line no-unused-vars
type OnChangeType = (category: CategoryConstantType) => any;

const Item: UIComponent<{ category: CategoryConstantType; onChange: OnChangeType }> = ({ category, onChange, ...props }) => {
  const { i18n } = useLingui();
  return (
    <Element
      {...props}
      onClick={() => {
        return onChange(category);
      }}
    >
      {i18n._(category.title)}
    </Element>
  );
};

const CategorySelector: UIComponent<{ onChange: OnChangeType; selected: CategoryConstantType }> = ({ className, onChange, selected }) => {
  const mediaQuery = useMediaQuery();
  const { i18n } = useLingui();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [selected]);

  return mediaQuery.down('md') ? (
    <Dropdown
      open={open}
      className={clsx(styles.root, className)}
      onOpen={() => {
        setOpen(!open);
      }}
      onClose={() => {
        setOpen(false);
      }}
      align="center"
    >
      <Dropdown.Trigger>
        <Button>
          <span>{i18n._(selected.title)}</span>
          <Icon name="chevron-right" className="rotate-90" />
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Content>
        <Item as={Dropdown.Item} onChange={onChange} category={categories.restaurants} />
        <Item as={Dropdown.Item} onChange={onChange} category={categories.movies} />
        <Item as={Dropdown.Item} onChange={onChange} category={categories.series} />
        <Item as={Dropdown.Item} onChange={onChange} category={categories.music} />
      </Dropdown.Content>
    </Dropdown>
  ) : (
    <div className={clsx(styles.root, className)}>
      <Item
        as={Button}
        variant={categories.restaurants.name === selected.name ? 'primary' : 'toggle'}
        onChange={onChange}
        category={categories.restaurants}
      />
      <Item as={Button} variant={categories.movies.name === selected.name ? 'primary' : 'toggle'} onChange={onChange} category={categories.movies} />
      <Item as={Button} variant={categories.series.name === selected.name ? 'primary' : 'toggle'} onChange={onChange} category={categories.series} />
      <Item as={Button} variant={categories.music.name === selected.name ? 'primary' : 'toggle'} onChange={onChange} category={categories.music} />
    </div>
  );
};

export default CategorySelector;
